// @flow

import * as React from 'react';

const useLayoutEffect =
  typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;

let windowSizeCache_ =
  typeof window === 'undefined'
    ? { innerWidth: 0, innerHeight: 0 }
    : {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
      };

export const useWindowSize = (): {|
  innerWidth: number,
  innerHeight: number,
|} => {
  const [size, setSize] = React.useState(windowSizeCache_);

  useLayoutEffect(() => {
    const updateSize = () => {
      const newSize = {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
      };
      windowSizeCache_ = newSize;
      setSize(prevSize =>
        prevSize.innerHeight === newSize.innerHeight &&
        prevSize.innerWidth === newSize.innerWidth
          ? prevSize
          : newSize,
      );
    };

    // listen window resize too
    const handleResize = () => {
      updateSize();
    };

    updateSize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return size;
};
